import { api } from "./api";

export const studentDetailsMain = async (id) => {
  return await api.get(`/student/detail/main?student_id=${id}`);
};

export const studentDetailsOverview = async (id) => {
  return await api.get(`/student/detail/overview?student_id=${id}`);
};

export const studentDetailsBasicDetails = async (id) => {
  return await api.get(`/student/detail/basic-details?student_id=${id}`);
};

export const studentDetailsFromDetails = async (id) => {
  return await api.get(`/student/detail/from-details?student_id=${id}`);
};

export const studentDetailsAcademicDetails = async (id) => {
  return await api.get(`/student/detail/academic-details?student_id=${id}`);
};

export const studentDetailsBatchNFeeDetails = async (id) => {
  return await api.get(`/student/detail/batch-fee-details?student_id=${id}`);
};
export const studentDetailsDeletedBatchNFeeDetails = async (id) => {
  return await api.get(
    `/student/detail/deleted/batch-fee-details?student_id=${id}`,
  );
};

export const studentDetailsAttendances = async (id, month) => {
  return await api.get("/student/detail/attendances", {
    params: {
      student_id: id,
      month: month,
    },
  });
};

export const studentDetailsTransactions = async (id) => {
  return await api.get(`/student/detail/transactions?student_id=${id}`);
};

export const studentBatchNFeeUpdateDiscount = async (data) => {
  return await api.post(`/student/batch-fee/update-discount`, data);
};

export const studentBatchNFeeStatusChange = async (data) => {
  return await api.post(`/student/batch-fee/status/change`, data);
};

export const studentTransportNFeeStatusChange = async (data) => {
  return await api.post(`/student/bus-fee/status/change`, data);
};

export const studentTransportNFeeUpdateDiscount = async (data) => {
  return await api.post(`/student/bus-fee/update-discount`, data);
};

export const studentDetailsMarkReport = async (id) => {
  return await api.get(`/student/detail/mark-report?student_id=${id}`);
};

export const studentDetailsTransportReport = async (id) => {
  return await api.get(`/student/detail/transport-report?student_id=${id}`);
};

export const studentDetailsHostelReport = async (id) => {
  return await api.get(`/student/detail/hostel-report?student_id=${id}`);
};

export const studentDetailsLibraryReport = async (id) => {
  return await api.get(`/student/detail/library-report?student_id=${id}`);
};

export const fetchStudentBatchFeeDetails = async (id) => {
  return await api.get(`/student/batch/fee/details/${id}`);
};

export const StudentBatchFeeSubjectUpdate = async (data) => {
  return await api.post(`student/batch/fee/update`, data);
};

export const studentBatchTransferHistory = async (id) => {
  return await api.get(`/student/batch/transfer/history/${id}`);
};

export const studentChangePassword = async (data) => {
  return await api.post(`/student/change/password`, data);
};
